$(function() {
    $('*[data-action="open-login-modal"]').on('click', function(){
        Manogi.openLoginModal();
    });

    $(document).on('click', '*[data-action="open-password-modal"]', function(){
        Manogi.openPasswordModal();
    });
});
